"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCategoryHasTranslation = exports.getCategoryUrl = exports.getLocalizedCategoryData = void 0;
function isIndexedCategory(category) {
    return 'name' in category && 'slug' in category;
}
function getLocalizedCategoryData(category, locale) {
    if (isIndexedCategory(category)) {
        return {
            description: null,
            name: category.name,
            slug: category.slug,
        };
    }
    const targetLocaleCode = locale.toUnderscoreCode();
    const translations = Object.values(category.i18n).filter((translation) => Boolean(translation.name));
    const targetTranslation = translations.find((translation) => translation.locale.code === targetLocaleCode) ??
        translations.find((translation) => translation.name === category.display_name) ??
        translations[0];
    const { locale: _, ...localizedData } = targetTranslation;
    return localizedData;
}
exports.getLocalizedCategoryData = getLocalizedCategoryData;
function getCategoryUrl(category, locale) {
    const { slug } = getLocalizedCategoryData(category, locale);
    return `/category/${slug}`;
}
exports.getCategoryUrl = getCategoryUrl;
function getCategoryHasTranslation(category, locale) {
    const translation = category.i18n[locale.toUnderscoreCode()];
    return Boolean(translation && translation.name);
}
exports.getCategoryHasTranslation = getCategoryHasTranslation;
//# sourceMappingURL=getLocalizedCategoryData.js.map